import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { BadgeComponent } from '../../../shared/components/ui/badge/badge.component';
import { ContactAttributeApiService } from '../services/contact-attribute-api.service';
import { ContactAttributeResponse } from '../models/contact-attribute.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

type BadgeColor = 'primary' | 'success' | 'error' | 'warning' | 'info' | 'light' | 'dark';

@Component({
  selector: 'app-contact-attribute-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PageBreadcrumbComponent,
    BadgeComponent,
    HasPermissionDirective
  ],
  templateUrl: './contact-attribute-list.component.html'
})
export class ContactAttributeListComponent implements OnInit {
  atributos: ContactAttributeResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private attributeApi: ContactAttributeApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.cargarAtributos();
  }

  cargarAtributos(): void {
    this.loading = true;
    this.error = '';

    const user = this.authService.getCurrentUser();
    const businessId = user?.businessId || 1;

    this.attributeApi.getAttributes(businessId).subscribe({
      next: (data) => {
        this.atributos = data;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Error al cargar los atributos de contacto';
        this.loading = false;
        console.error('Error:', err);
      }
    });
  }

  nuevoAtributo(): void {
    this.router.navigate(['/config-contactos/atributos/crear']);
  }

  editarAtributo(atributo: ContactAttributeResponse): void {
    this.router.navigate(['/config-contactos/atributos/editar', atributo.id]);
  }

  async eliminarAtributo(atributo: ContactAttributeResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar atributo',
      message: `¿Está seguro de eliminar el atributo "${atributo.displayName}"?`
    });
    if (!ok) return;
    const user = this.authService.getCurrentUser();
    const businessId = user?.businessId || 1;

    this.attributeApi.deleteAttribute(atributo.id, businessId).subscribe({
      next: () => {
        this.cargarAtributos();
        this.toast.deleted('Atributo de contacto', `Se eliminó "${atributo.displayName}" correctamente.`);
      },
      error: (err) => {
        this.toast.error({ title: 'Error', message: err.error?.message || 'Error al eliminar el atributo' });
      }
    });
  }

  getValueTypeColor(valueType: string): BadgeColor {
    if (valueType === 'STRING') return 'info';
    if (valueType === 'NUMBER') return 'warning';
    return 'primary';
  }

  getValueTypeLabel(valueType: string): string {
    if (valueType === 'STRING') return 'Texto';
    if (valueType === 'NUMBER') return 'Número';
    return 'Clave Foránea';
  }

  getActiveColor(isActive: boolean): BadgeColor {
    return isActive ? 'success' : 'error';
  }

  getActiveLabel(isActive: boolean): string {
    return isActive ? 'Activo' : 'Inactivo';
  }
}
